import {MessageBase} from './message-base';
import {DataSeries} from '../DoraData/data-series';

export class MessageSeriesSelected  extends MessageBase<MessageSeriesSelected> {
  private datasSeries: DataSeries[] = [];


  constructor(dataSeries: DataSeries[]) {
    super(MessageSeriesSelected);
    this.datasSeries = dataSeries;
  }


  get DatasSeries(): DataSeries[] {
    return this.datasSeries;
  }
}
